export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/profileIconGreen.44aecc0e.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};